import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import type { InvitationDetails } from "../types/invitation";

export function useInvitation(invitationId: string | undefined) {
  return useQuery({
    queryKey: ["invitation", invitationId],
    queryFn: () => api<InvitationDetails>(`/invitations/${invitationId}`),
  });
}
